import { NOVA } from "../../routes";

/** What another page hands Nova in router state: an update to start the Write step with. */
export type NovaHandover = { text?: string };

/** Nova's router state, read on arrival; anything else is no handover. */
export const readNovaHandover = (state: unknown): NovaHandover => {
  const { text } = (state ?? {}) as NovaHandover;
  return typeof text === "string" && text.trim() ? { text } : {};
};

/** Opens Nova's Write step with what someone typed filled in. */
export const toNova = (text: string) => ({
  pathname: NOVA,
  state: { text } satisfies NovaHandover,
});
